import { composeShadow, pxToRem, staticColors } from '@bos/ui';
import { styled } from 'styletron-react';
export const StyledSnackbarWrapper = styled('div', {
    backgroundColor: staticColors.snackbarBackground,
    boxShadow: composeShadow({
        x: pxToRem(0),
        y: pxToRem(14),
        blur: pxToRem(20),
        spread: pxToRem(0),
        color: staticColors.snackbarShadow,
    }),
    padding: pxToRem(16),
    borderRadius: pxToRem(6),
});
